import { Box } from '@mui/material';

export default function AvatarPreview({ file }) {
  if (!file) {
    return null;
  }

  const imgUrl = typeof file === 'string' ? file : file.preview;
  return (
    <Box
      component="img"
      src={imgUrl}
      sx={{
        zIndex: 8,
        overflow: 'hidden',
        objectFit: 'cover',
        borderRadius: '50%',
        position: 'absolute',
        width: `calc(100% - 16px)`,
        height: `calc(100% - 16px)`,
      }}
    />
  );
}
